import {
  mapper,
  mapActionItem,
  mapCarouselSliderItemLight,
} from '@shared/lib';
import {
  mapGameCategoryBlock
} from '@widgets/games-by-categories-block';
import {
  type LobbyPageState
} from '../model';
import {
  mapPlayInThreeSteps
} from './map-play-in-three-steps';

type MapLobbyPageState = (data: unknown) => LobbyPageState;
export const mapLobbyPageState: MapLobbyPageState = mapper([
  { name: 'title', from: 'data.attributes.title' },
  { name: 'keywords', from: 'data.attributes.keywords' },
  { name: 'canonical', from: 'data.attributes.canonical' },
  { name: 'description', from: 'data.attributes.description' },
  {
    name: 'playInThreeSteps',
    from: 'data.attributes.playInThreeSteps',
    transform: (playInThreeStepsData: unknown) => mapPlayInThreeSteps(playInThreeStepsData),
  },
  {
    name: 'slider',
    from: 'data.attributes.carouselSlider',
    transform: (sliderItemsData: Array<unknown>) => sliderItemsData?.map(mapCarouselSliderItemLight),
  },
  {
    name: 'gamesByCategoriesBlockAfterCarouselSlider',
    from: 'data.attributes.gamesByCategoriesBlockAfterCarouselSlider',
    transform: (gameCategoriesData: Maybe<Array<{ data: unknown }>>) => {
      return gameCategoriesData?.map(data => mapGameCategoryBlock(data));
    }
  },
  {
    name: 'gamesByCategoriesBlockAfterChallengeList',
    from: 'data.attributes.gamesByCategoriesBlockAfterChallengeList',
    transform: (gameCategoriesData: Maybe<Array<{ data: unknown }>>) => {
      return gameCategoriesData?.map(data => mapGameCategoryBlock(data));
    }
  },
  {
    name: 'gamesByCategoriesBlockAfterLatestWinners',
    from: 'data.attributes.gamesByCategoriesBlockAfterLatestWinners',
    transform: (gameCategoriesData: Maybe<Array<{ data: unknown }>>) => {
      return gameCategoriesData?.map(data => mapGameCategoryBlock(data));
    }
  },
  {
    name: 'gamesByCategoriesBlockAfterMiniLeaderboard',
    from: 'data.attributes.gamesByCategoriesBlockAfterMiniLeaderboard',
    transform: (gameCategoriesData: Maybe<Array<{ data: unknown }>>) => {
      return gameCategoriesData?.map(data => mapGameCategoryBlock(data));
    }
  },
  {
    name: 'gamesByCategoriesBlockAfterTreasureChests',
    from: 'data.attributes.gamesByCategoriesBlockAfterTreasureChests',
    transform: (gameCategoriesData: Maybe<Array<{ data: unknown }>>) => {
      return gameCategoriesData?.map(data => mapGameCategoryBlock(data));
    }
  },
  {
    name: 'gamesByCategoriesBlockAfterTournamentsList',
    from: 'data.attributes.gamesByCategoriesBlockAfterTournamentsList',
    transform: (gameCategoriesData: Maybe<Array<{ data: unknown }>>) => {
      return gameCategoriesData?.map(data => mapGameCategoryBlock(data));
    }
  },
  {
    name: 'gamesByCategoriesBlockAfterPlayInThreeSteps',
    from: 'data.attributes.gamesByCategoriesBlockAfterPlayInThreeSteps',
    transform: (gameCategoriesData: Maybe<Array<{ data: unknown }>>) => {
      return gameCategoriesData?.map(data => mapGameCategoryBlock(data));
    }
  },
  {
    name: 'tournamentWidgetTitle',
    from: 'data.attributes.tournamentWidgetTitle'
  },
  {
    name: 'tournamentWidgetVisibleOnMobile',
    from: 'data.attributes.tournamentWidgetVisibleOnMobile'
  },
  {
    name: 'action',
    from: 'data.attributes.action',
    transform: (data: Array<unknown>) => {
      if (!Array.isArray(data)) return null;
      return data?.map(actionItem => mapActionItem(actionItem));
    }
  },
]);
